import { render, staticRenderFns } from "./GestioneAttivitaAttivitaListSelectModal.vue?vue&type=template&id=ce2e4f28"
import script from "./GestioneAttivitaAttivitaListSelectModal.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaAttivitaListSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports